<template>
  <v-dialog
      :value="showLoader"
      persistent
      width="300"
    >
      <v-card
        color="blue"
        dark
      >
        <v-card-text>
          {{ message }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'loader-dialog',
  props: ['showLoader', 'message'],
};
</script>




// WEBPACK FOOTER //
// src/components/LoaderDialog.vue